import React from 'react';

interface SocketCloudIconProps {
  className?: string;
  size?: number;
  color?: string;
}

/**
 * SocketCloud favicon icon from the website project
 * Optimized SVG cloud icon with enterprise branding
 */
export const SocketCloudIcon: React.FC<SocketCloudIconProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
}) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 220 160" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        fill={color} 
        d="M81.66,109.66c.19,9.02-1.15,18.06,3.36,26.44,4.53,8.44,11.18,14.31,20.31,17.3,3.6,1.18,5.41,3.57,5.41,7.39.01,6.58.01,13.16,0,19.74,0,3.34-1.18,4.52-4.49,4.54-1.4,0-2.8.03-4.19,0-2.76-.05-4.05-1.32-4.06-4.07-.02-5.13-.06-10.25.01-15.38.02-1.18-.34-1.71-1.44-2.18-2.08-.88-4.16-1.85-6.05-3.07-1.55-1-3.08-1.37-4.89-1.36-9.67.06-19.34,0-29.01.03-28.83.11-51.56-20.62-55.88-47.14-4.68-28.7,13.21-56.3,41.5-63.2,3.31-.81,6.76-1.03,10.16-1.43,1.07-.13,1.55-.55,1.89-1.58C62,22.2,77.71,6.8,101.91,1.62c22.97-4.92,43.3,1.46,60.02,18.2,7.27,7.28,12.35,15.99,15.33,25.86.52,1.72,1.68,1.67,2.93,1.74,7.7.47,15.05,2.39,21.82,6.05,15.89,8.6,25.71,21.82,28.98,39.62,3.08,16.73-.85,31.91-11.38,45.19-8.48,10.7-19.63,17.26-33.11,19.77-7.91,1.47-15.89.91-23.85,1-5.88.06-11.77-.03-17.65.05-.98.01-2.01.41-2.91.84-2.19,1.06-4.28,2.33-6.49,3.36-1.03.48-1.49,1-1.47,2.2.07,5.07.04,10.13.03,15.2,0,3.11-1.21,4.33-4.3,4.37-1.57.02-3.15.02-4.72-.03-2.01-.07-3.38-1.23-3.4-3.22-.07-7.63-.15-15.26.05-22.88.08-3.01,2.32-4.68,5.08-5.52,6.18-1.89,11.3-5.39,15.53-10.23,5.34-6.1,8.04-13.26,8.29-21.32.11-3.55,0-7.11.05-10.66.02-1.14-.28-1.69-1.56-1.69-22.19.03-44.38.02-66.57.02-.23,0-.45.06-.94.13Z"
      />
    </svg>
  );
};

export default SocketCloudIcon;